import {
    types as ActionTypes,
    asyncEvents as AsyncEvents,
    statusEvents as StatusEvents,
} from './RequestDetails.actions';
import {
    CRUDDetailsReducers,
    errorReducer,
    genericReducer,
    loadingReducer,
} from '/b2b/common/helpers/ReduxHelpers';
import {
    default as conversation,
    initialState as initialConversationState,
} from './conversation/RequestConversation.reducer';

import { types as AuthActionTypes } from '/b2b/authentication/state/Auth.actions';
import AuthenticatedPaths from '/b2b/routing/AuthenticatedRoutes/AuthenticatedRoutes.paths';
import { types as NavActionTypes } from '/b2b/common/state/nav/Nav.actions';
import { combineReducers } from 'redux';
import { matchPath } from 'react-router-dom';
import reduceReducers from 'reduce-reducers';
import schema from '../db/Request.schema';

export const initialState = {
    actionItems: [],
    actionItemsCreating: false,
    actionItemsLoading: false,
    auditEvents: [],
    auditEventsLoading: true,
    conversation: initialConversationState,
    dataStoresLoading: true,
    emailNotificationSent: false,
    error: null,
    id: '',
    hasDataStores: false,
    loading: true,
    statusError: null,
    statusUpdating: false,
    summaries: [],
    summariesLoading: false,
    summariesPackaging: false,
    viewedStatus: null,
};

export default reduceReducers(
    initialState,
    combineReducers({
        actionItems: genericReducer(initialState.actionItems, {
            [ActionTypes.setActionItems]: (state, actionItems) => actionItems,
        }),
        actionItemsCreating: genericReducer(initialState.actionItemsCreating, {
            [ActionTypes.setActionItemsCreating]: (state, actionItemsCreating) =>
                actionItemsCreating,
        }),
        actionItemsLoading: genericReducer(initialState.actionItemsLoading, {
            [ActionTypes.setActionItemsLoading]: (state, actionItemsLoading) => actionItemsLoading,
        }),
        auditEvents: genericReducer(initialState.auditEvents, {
            [ActionTypes.setAuditEvents]: (state, auditEvents) => auditEvents,
        }),
        auditEventsLoading: genericReducer(initialState.auditEventsLoading, {
            [ActionTypes.setAuditEventsLoading]: (state, auditEventsLoading) => auditEventsLoading,
        }),
        conversation,
        dataStoresLoading: genericReducer(initialState.dataStoresLoading, {
            [ActionTypes.setDataStoresLoading]: (state, dataStoresLoading) => dataStoresLoading,
        }),
        emailNotificationSent: genericReducer(initialState.emailNotificationSent, {
            [ActionTypes.setEmailNotificationSent]: (state, emailNotificationSent) =>
                emailNotificationSent,
        }),
        error: errorReducer(
            initialState.error,
            Object.keys(AsyncEvents).map(key => ActionTypes[key]),
            schema
        ),
        hasDataStores: genericReducer(initialState.hasDataStores, {
            [ActionTypes.setHasDataStores]: (state, hasDataStores) => hasDataStores,
        }),
        statusError: errorReducer(
            initialState.statusError,
            Object.keys(StatusEvents).map(key => ActionTypes[key]),
            schema
        ),
        statusUpdating: loadingReducer(
            initialState.statusUpdating,
            Object.keys(StatusEvents).map(key => ActionTypes[key]),
            schema
        ),
        summaries: genericReducer(initialState.summaries, {
            [ActionTypes.setSummaries]: (state, summaries) => summaries,
        }),
        summariesLoading: genericReducer(initialState.summariesLoading, {
            [ActionTypes.setSummariesLoading]: (state, summariesLoading) => summariesLoading,
        }),
        summariesPackaging: genericReducer(initialState.summariesPackaging, {
            [ActionTypes.setSummariesPackaging]: (state, summariesPackaging) => summariesPackaging,
        }),
        viewedStatus: genericReducer(initialState.viewedStatus, {
            [ActionTypes.setViewedStatus]: (state, viewedStatus) => viewedStatus,
        }),
        ...CRUDDetailsReducers(
            initialState,
            Object.keys(AsyncEvents).map(key => ActionTypes[key]),
            schema
        ),
    }),
    genericReducer(initialState, {
        [AuthActionTypes.logout]: () => initialState,
        [NavActionTypes.routeChanged]: (state, payload) => {
            const { location, action } = payload;
            const match = matchPath(
                location.pathname,
                `${AuthenticatedPaths.DSAR_REQUESTS}/:requestId`
            );
            const { params: { requestId } = {} } = match || {};
            if (action === 'LOAD' && match) {
                return {
                    ...state,
                    id: requestId,
                };
            }
            if (!match) {
                return initialState;
            }
            return state;
        },
    })
);
